<template>
  <div class="main">
    <my_menu></my_menu>

    <div class="content">
      <div>
        <div v-for="(item, i) in dep_list" :key="i" class="team_div">
          <div class="team_title">
            {{ item.label }}
          </div>

          <div
            v-for="(child_item, child_index) in item.children"
            :key="child_index"
            class="child_div"
          >
            <div class="child_title">
              {{ child_item.label }}
            </div>
            <div>
              <Tag
                closable
                @on-close="user_del(child_item.value, user_item)"
                v-for="(user_item, user_index) in child_item.user_list"
                :key="user_index"
                color="primary"
                >{{ user_item.name }}</Tag
              >
              <Tag class="add_user" @click="click_add(child_item)">+添加</Tag>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="add_user_show"
      title="添加用户"
      :mask-closable="false"
      :footer-hide="true"
      width="300"
    >
      <Select v-model="add_user_id" filterable>
        <Option v-for="item in user_list" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>

      <div class="confirm_div">
        <Button type="primary" @click="add_user_confirm">确认添加</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,
      add_field_show: false,

      dep_list: [],
      user_list: [],

      add_user_show: false,
      add_user_id: "",
      add_dep_id: "",
    };
  },

  mounted() {
    this.window_change();
    this.get_dep_list();
    this.get_user_list();
  },

  methods: {
    user_del(dep_id, item) {
      var that = this;

      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除权限，是否确认</p>",
        onOk: () => {
          var obj = {
            dep_id: dep_id,
            user_id: item.user_id,
          };
          that.table_loading = true;
          http(
            "post",
            process.env.VUE_APP_HOST + "/panel_manage/xiangmu/del_user",
            obj,
            true
          )
            .then((res) => {
              if (res.code == 0) {
                that.$Message.success({
                  content: res.msg,
                  duration: 3,
                });
                that.get_dep_list();
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              console.log(res, "请求出错");
            });
        },
        onCancel: () => {},
      });
    },

    //添加用户
    add_user_confirm() {
      var that = this;
      var obj = {
        dep_id: this.add_dep_id,
        user_id: this.add_user_id,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/panel_manage/xiangmu/add_user", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_user_show = false;
            that.get_dep_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_add(item) {
      console.log(item);
      this.add_dep_id = item.value;
      this.add_user_show = true;
    },

    get_user_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/panel_manage/xiangmu/sys_user_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取部门列表
    get_dep_list() {
      var that = this;
      var obj = {
        page: this.page,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/panel_manage/xiangmu/dep_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.dep_list = res.data.dep_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.confirm_div {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0 0 0;
}

.team_div {
  padding: 10px;
  background-color: #fff;
  margin-bottom: 10px;
}

.child_div {
  margin: 10px;
  padding: 5px;
}

.team_title {
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.add_user {
  cursor: pointer;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.child_title {
  font-size: 13px;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 180px);
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100vh;
  overflow: auto;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
